import { UPDATE_CONFIGURACOES } from "../constants/Configuracoes";

const initState = {
	financeiro_ativo: false,
	financeiro_ativo_asaas: false,
	comunidade_ativa: false,
	comunidade_permitir_comentarios: true,
	comunidade_permitir_posts_alunos: true,
	gamificacao_ativa: false,
};

const configuracoes = (state = initState, action) => {
	switch (action.type) {
		case UPDATE_CONFIGURACOES:
			return {
				...state,
				...action.configuracoes,
			};
		default:
			return state;
	}
};

export default configuracoes;

